import type React from "react"
import { memo } from "react"

interface MappingSummaryProps {
  totalMappings: number
  hubspotFieldsCount: number
  salesforceFieldsCount: number
}

const MappingSummary: React.FC<MappingSummaryProps> = memo(
  ({ totalMappings, hubspotFieldsCount, salesforceFieldsCount }) => (
    <div className="mapping-summary">
      <div className="summary-item">
        <span className="summary-label">Total Mappings:</span>
        <span className="summary-value">{totalMappings}</span>
      </div>
      <div className="summary-item">
        <span className="summary-label">HubSpot Fields:</span>
        <span className="summary-value">{hubspotFieldsCount}</span>
      </div>
      <div className="summary-item">
        <span className="summary-label">Salesforce Fields:</span>
        <span className="summary-value">{salesforceFieldsCount}</span>
      </div>
    </div>
  ),
)

MappingSummary.displayName = "MappingSummary"

export default MappingSummary
